import React from 'react';
import { IStateBase, BaseComponent } from 'components/BaseComponent';
import { IProductData, IProductConfig } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { IPayProps } from 'components/Cart';
import { paymentService } from 'services/PaymentService';
import { Observable } from 'rxjs/Observable';
import { HistoryContext } from 'shared/HistoryContext';
import { History } from 'history';
import { enStep } from 'components/Cart/Templates/Hotsite/MultiStep';
import Footer from 'components/Cart/Footer';
import Paper from '@material-ui/core/Paper/Paper';
import Typography from '@material-ui/core/Typography/Typography';
import YoutubeEmbed from 'components/YoutubeEmbed/index';
import { ContentOneClickBuy } from './ContentOneClickBuy';
import AskAddress from 'components/Cart/AskAddress';
import Translate from 'components/Translate';
import Divider from '@material-ui/core/Divider/Divider';
import { userService } from 'services/UserService';

const styles = require('./oneClickBuy.css');

interface IState extends IStateBase {
  cart: IProductData;
  step: enStep;
  config: IProductConfig;
  showAskAddress: boolean;
}

export interface IStepProps {
  setStep: (step: enStep) => void;
}

interface IProps extends IPayProps {
  hiddenFooter?: boolean;
}

export default class OneClickBuy extends BaseComponent<IState, IProps> {
  private history: History;

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ config: null }, cartService.getConfig());
    this.setState({ showAskAddress: false });

    cartService
      .getCart()
      .filter(cart => !cart.isCached && cart.upsell && !cart.config.askCVV)
      .take(1)
      .subscribe(() => {
        this.onPay();
      });

  }

  public setStep(step: enStep) {

    const { config } = this.state;
    if (step == enStep.address && !config.askAddressBeforePayment) {
      step = enStep.payment;
    }

    userService.setBasicUser().subscribe();

    this.setState({ step });
  }

  onPay = async () => {
    if (await this.isFormValid()) {
      this.props
        .onPay()
        .switchMap(() => cartService.getCart())
        .take(1)
        .switchMap(cart => {

          if (cart.config.askAddressAfterPayment) {
            this.setState({ showAskAddress: true });
            return Observable.of(`#`);
          }

          return paymentService.getPaymentResult()
            .map(result => {

              if (result.redirectTo) {
                Observable
                  .never()
                  .loader()
                  .subscribe();

                window.location.href = result.redirectTo;
                return null;
              }

              return `/thankyou/${cart.contentId}/${result.key}`;
            });
        })
        .filter(url => url !== null)
        .bindComponent(this)
        .subscribe(url => {
          this.history.push(url);
        });
    }
  }

  setHistory(history: History): any {
    this.history = history;
    return null;
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart, showAskAddress } = this.state;
    const description = this.state.cart.products[0].description;
    return (
      <div className={styles.component}>
        <HistoryContext.Consumer>
          {h => this.setHistory(h)}
        </HistoryContext.Consumer>
        <div className={'chk-oneClickBuy__desktop'}>
          <div className={'chk-oneClickBuy__container'}>
            {showAskAddress ? <AskAddress />
              : <ContentOneClickBuy cart={cart} onPay={this.onPay} />}
          </div>
          <div className='description-banner'>
            <Paper className={'description-card'} elevation={0}>
              {this.state.cart.config.template.media.bannerYoutube ?
                <div className='banner'>
                  <YoutubeEmbed url={this.state.cart.config.template.media.bannerYoutube} />
                </div>
                : ''
              }
              <div className='description'>
                <Typography variant='h5' component='h3'>
                  <b><Translate term='Detalhes' /></b>
                </Typography>

                <div dangerouslySetInnerHTML={{ __html: description }} />

                <Divider />
                <div className='infos-producer'>
                  <Typography component='span' className='infos-details'>
                    <Translate term='Oferecido por' /> <b>{this.state.cart.products[0].producerName}</b>
                  </Typography>
                  <Typography component='span' className='infos-details'>
                    {this.state.cart.products[0].producerEmail}
                  </Typography>
                </div>
              </div>
            </Paper>
          </div>
        </div>
        {!this.props.hiddenFooter
          ? <div className='links'>
            <Footer />
          </div>
          : null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/OneClickBuy/index.tsx